/**
 * OnboardingStatus constants that match the backend enum values.
 */
export const OnboardingStatus = {
    JOB_CREATED: 'JobCreated',
    IN_PROGRESS: 'InProgress',
    COMPLETED: 'Completed',
    CANCELLED: 'Cancelled',
    FAILED: 'Failed',
    READY_FOR_NETRADYNE_DISSOCIATION: 'ReadyForNetradyneDissociation',
} as const;

export const fromValue = (value: string | undefined): string | undefined => {
    if (!value) {
        return undefined;
    }

    const key = Object.keys(OnboardingStatus).find((k) => k === value);
    return key ? OnboardingStatus[key as keyof typeof OnboardingStatus] : value;
};

/**
 * Mirrors OnboardingStatus.isInstallComplete() on the backend. ReadyForNetradyneDissociation
 * overwrites Completed in place, so a device carrying it has a finished install.
 */
export const isInstallComplete = (value: string | undefined): boolean =>
    value === OnboardingStatus.COMPLETED || value === OnboardingStatus.READY_FOR_NETRADYNE_DISSOCIATION;

/** Technician-facing text for the statuses that have no readable value of their own. */
export const toStatusLabel = (value: string | undefined): string | undefined =>
    value === OnboardingStatus.READY_FOR_NETRADYNE_DISSOCIATION ? 'Completed, Netradyne dissociation requested' : value;
